import { Link } from "react-router-dom";
import styles from "./StatisticCard2.module.scss"


function StatisticsCard2 ({number, title, id}){
    return(
        <Link to={`/statistics/${id}`} className={styles.cardWrapper}>
            <div className={styles.card}>
                <div className={styles.round}>
                    <p>{number}</p>
                </div>
                <p className={styles.title}>{title}</p>
            </div>
        </Link>
    )
}
export default StatisticsCard2;